// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
      	defaultDisplay: 'grid',
      	filterTreeMobileStyle: 'style1',
        paginationTypeAdvanced: true,
	},
  	label: {
      	ratingUp: "& üstü",
        action_list: {
            atcAvailableLabel: "Sepete Ekle",
            atcSoldOutLabel: "Tükendi"
        }
    },
//     actionlist: {
//       alStyle: "bc-al-style6",
//       qvEnable: false
//     }
};

// Declare Templates
var boostPFSTemplate = {
	'soldOutClass': 'is-sold-out',

    'saleLabelHtml': '<div class="grid-product__on-sale"><p>{{saleLabel}}</p></div>',
    'soldOutLabelHtml': '<div class="grid-product__sold-out"><p>' + boostPFSConfig.label.sold_out + '</p></div>',
    'vendorHtml': '<p class="grid-product__vendor">{{vendor}}</p>',

    // Collage Template
    'productCollageItemHtml': '{{startCollageWrapper}}<div class="grid__item grid-product {{itemGridWidthClass}} {{soldOutClass}}" data-page={{page}}>' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<div class="grid-product__wrapper notHeighted">' +
                                    '<div class="grid-product__image-wrapper">' +
                                        '<a class="grid-product__image-link" href="{{itemUrl}}">' +
                                            '<img class="grid-product__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        '</a>' +
                                        '{{itemSoldOutLabel}}' +
                                        '{{itemSaleLabel}}' +
                                    '</div>' +
                                    '<a href="{{itemUrl}}" class="grid-product__meta">' +
                                        '<span class="grid-product__title">{{itemTitle}}</span>' +
  										
                                        '<span class="grid-product__price-wrap"><span class="grid-product__price">{{itemPrice}}</span></span>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
                                '</div>' +
                            '</div>{{endCollageWrapper}}',

    // Grid Template
    'productGridItemHtml': '<div class="grid__item grid-product medium--one-half large--one-third {{soldOutClass}}" data-page={{page}}>' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<div class="grid-product__wrapper notHeighted">' +
                                    '<div class="frcp-wishlist-grid-btn-wrapper frcp-wishlist-grid-btn-wrapper--overlay" data-frcp-product-id="{{product.id}}" data-frcp-product-handle="{{product.handle}}"></div>' +
                                    '<div class="grid-product__image-wrapper">' + 
                                    '<span class="smartwishlist" data-product="{{SWProductId}}" data-variant="{{SWVariantId}}"></span>'+ 
                                        '<a class="grid-product__image-link" href="{{itemUrl}}">' +
                                            '<img class="grid-product__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
                                        '</a>' +
                                        '{{itemSoldOutLabel}}' +
                                        '{{itemSaleLabel}}' +
                                    '</div>' +
                                    '<a href="{{itemUrl}}" class="grid-product__meta">' +
  										'<div class="item-flair-wrapper">{{itemFlairHtml}}</div>'+
                                        '<span class="grid-product__title">{{itemTitle}}</span>' +
                                        '{{itemReviews}}' +
                                        '<span class="grid-product__price-wrap"><span class="grid-product__price">{{itemPrice}}</span></span>' +
                                        '{{itemVendor}}' +
                                    '</a>' +
                                '</div>' +
                            '</div>',

    // Pagination Template
    'previousHtml': '<span class="prev"><a href="{{itemUrl}}"><span class="icon-fallback-text"><span class="icon icon-arrow-left" aria-hidden="true"></span><span class="fallback-text">Previous</span></span></a></span>',
    'nextHtml': '<span class="next"><a href="{{itemUrl}}"><span class="icon-fallback-text"><span class="icon icon-arrow-right" aria-hidden="true"></span><span class="fallback-text">Next</span></span></a></span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span>{{itemTitle}}</span>',
    'paginateHtml': '<div class="pagination">{{previous}}{{pageItems}}{{next}}</div>',
  
  	// Sorting template
  	'sortingHtml': '<label for="sortBy">Ürünleri Sırala</label>' +
                   '<select name="sortBy" id="sortBy">{{sortingItems}}</select>',
};



(function () {
	BoostPFS.inject(this);
  
    var is_three_row__product = false;
    var is_reverse_row__product = false;
    var three_row_index__product = 0;

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

	
		// Add soldOut class
        var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

        // Add soldOut and onSale label
        if (soldOut) {
            itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, boostPFSTemplate.soldOutLabelHtml);
        } else {
            itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
            if (onSale) {
                 var percentOff = 'İNDİRİMLİ';
                itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, boostPFSTemplate.saleLabelHtml.replace(/{{saleLabel}}/g, percentOff));

            }
        }
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');

        // Add Thumbnail
        var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], 'grande') : boostPFSAppConfig.general.no_image_url;
        itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

        // Add Vendor
        var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
        itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

        // Add Price
        var itemPriceHtml = '';
        if (onSale) {
            itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.sale_price + '</span>';
        } else {
            itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
        }
        if (priceVaries) {
            itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
            itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
        } else {
            itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
        }
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

        // Add data json
        var self = this;
        var itemJson = {
          "id": data.id,
          "title": data.title,
          "handle": data.handle,
          "vendor": data.vendor,
          "variants": data.variants,
          "url": Utils.buildProductItemUrl(data),
          "options_with_values": data.options_with_values,
          "images": data.images,
          "available": data.available,
          "price_min": data.price_min,
            "price_max": data.price_max,
            "compare_at_price_min": data.compare_at_price_min,
            "compare_at_price_max": data.compare_at_price_max,
        };
        itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));
         //Review 
        var itemJudgemeHtml = '';
        if (Utils.getProductMetafield(data, 'judgeme', 'badge') !== null) {
            itemJudgemeHtml = "<div class='jdgm-widget jdgm-preview-badge' data-id='" + data.id + "'>" + Utils.getProductMetafield(data, 'judgeme', 'badge').replace(/\|/g, '"') + "</div>";
        }
        itemHtml = itemHtml.replace(/{{itemJudgeme}}/g, itemJudgemeHtml);
      
        // Flair
        // var itemFlairHtml = '';
        // if(Utils.getProductMetafield(data, 'flair', 'badge')){
        //     itemFlairHtml = Utils.getProductMetafield(data, 'flair', 'badge');
        // }
        var itemFlairHtml = `<div class="flair-badge-layout" data-flair-product-badge data-product-id="${data?.id}" data-flair-product-id="${data?.id}"></div>`;
        itemHtml = itemHtml.replace(/{{itemFlairHtml}}/g, itemFlairHtml);


        //Smart Wishlist    
        itemHtml = itemHtml.replace(/{{SWProductId}}/g, data.id);
        itemHtml = itemHtml.replace(/{{SWVariantId}}/g, data.variants[0].id);    

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {

		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);


		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage in pageArr) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content 
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}

		return '';
	};

	// Build additional attributes of product items
	ProductList.prototype.afterRender = function(data) {

		if (!data) data = this.data;
      
        $(document).ready(function() {
          theme.init();
          var sections = new theme.Sections();
          sections.register('collection-template', theme.Collection);
        });
      
        // Integrate Stamped.io Reviews
        var self = this;
        if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function') {
          StampedFn.loadBadges();
        }
      
        if (theme.settings.cartType == 'drawer') {
          ajaxCart.init({
            formSelector: '.boost-pfs-addtocart-product-form',
            cartContainer: '#CartContainer',
            addToCartSelector: '.boost-pfs-addtocart-btn',
            enableQtySelectors: true,
            moneyFormat: theme.strings.moneyFormat
          });
        }
        /* end-initialize-bc-al */

        //Smart Wishlist
        if (typeof ReloadSmartWishlist !== "undefined" && $.isFunction(ReloadSmartWishlist)) ReloadSmartWishlist();
        // Customer Accounts Concierge Wishlist
        // if (window.frcp && frcp.wishlist) frcp.wishlist.attachOnCollection();
        if (window.frcp && frcp.wishlist && frcp.wishlist?.attachOnCollection) frcp.wishlist.attachOnCollection();
       if (typeof FlairApp !== 'undefined' && FlairApp) {
            FlairApp.refreshProductBadges();
          }
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
      if (!data) data = this.data;
      
      $('#boost-pfs-search-box-mobile').attr('placeholder', 'Arama yap');
      var self = this;
      if(Utils.isMobile()){
        setTimeout(function(){
          var previousElement = null
          var previousElementHeight = 0
          var longestHeight = 0;
          jQ("[data-page="+Globals.queryParams.page+"] .grid-product__wrapper.notHeighted").each(function(index){
            console.log(jQ(this))
            if(previousElement === null){
              previousElement = jQ(this);
              previousElementHeight = jQ(this).height()
            }else{
              longestHeight = jQ(this).height() > previousElementHeight ? jQ(this).height() : previousElementHeight;
              jQ(this).height(longestHeight)
              jQ(this).removeClass("notHeighted")
              previousElement.height(longestHeight)
              previousElement.removeClass("notHeighted")
              previousElementHeight = 0;
              previousElement = null;
            }
          })
        } , 1200)
    }
    };

	Utils.buildProductItemVendorUrl = function(vendor){
		return window.location.protocol + '//' + window.location.hostname + '/collections/vendors?q=' + this.encodeURIParamValue(vendor);
	};

  	BoostOTP.inject(this);
  	OTPButtons.render = function(product) {
        if ((product.quickView && product.quickView.$element) || (product.addToCart && product.addToCart.$element)) {
            // Append the OTP wrapper
            var wrapperHtml = '<div class="boost-pfs-action-list-wrapper boost-pfs-action-extend"></div>';

            if (Selector.otpButtons) {
                product.$element.find(Selector.otpButtons).append(wrapperHtml);
            } else {
                if (Utils.isMobile() || Utils.isTablet()) {
                  	product.$element.find('.grid-product__image-wrapper').append(wrapperHtml);
                } else {
					product.$element.append(wrapperHtml);
                }
            }

            product.$element.addClass('boost-pfs-action-list-enabled');
            product.$element.find('img').parent().addClass('boost-pfs-action-overlay');
            if ((product.quickView && !product.addToCart) || (product.addToCart && !product.quickView) || (product.addToCart && product.quickView && product.quickView.isHidden)) {
               product.$element.addClass('boost-pfs-action-list-single-button');
            }

            if ((product.quickView && !product.addToCart) || (product.addToCart && !product.quickView)) {
                product.$element.addClass('boost-pfs-action-list-single-button');
            }

            // Check which order to append quickview & add to cart
            var styleClass = Settings.getSettingValue('actionlist.alStyle');
            var reverseOrderStyles = ['bc-al-style3','bc-al-style4'];

            // Append the buttons inside wrapper
            if (reverseOrderStyles.includes(styleClass)) {
                if (product.addToCart && product.addToCart.$element) {
                    product.$element.find('.boost-pfs-action-list-wrapper').append(product.addToCart.$element);
                }
                if (product.quickView && product.quickView.$element) {
                    product.$element.find('.boost-pfs-action-list-wrapper').append(product.quickView.$element);
                }
            } else {
                if (product.quickView && product.quickView.$element) {
                    product.$element.find('.boost-pfs-action-list-wrapper').append(product.quickView.$element);
                }
                if (product.addToCart && product.addToCart.$element) {
                    product.$element.find('.boost-pfs-action-list-wrapper').append(product.addToCart.$element);
                }
            }

            // Set OTP class on product list
            var $productList = product.$productList || product.$element.closest('.boost-pfs-filter-products');

            if ($productList && !$productList.hasClass(styleClass)) {
                $productList.addClass(styleClass);
            }
            // if (!product.$productList.hasClass(styleClass)) {
            //     !product.$productList.addClass(styleClass)
            // }
        }
    }
  

    window.addEventListener("pageshow", function(evt){
      if(evt.persisted && Utils.isiOS()){
          location.reload();
        }
    }, false);
})();